export default __webpack_public_path__ + "static/media/586.831c0db2.gif";